import React from 'react'

export default ({ children }) => {
  return (
    <span className="px-2 py-1 text-xs text-black bg-black rounded bg-opacity-10 text-opacity-70">
      {children}
    </span>
  )
}
